import React from "react";

import Card from "@material-ui/core/Card";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Tooltip from '@mui/material/Tooltip';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

import Style from "../../../../styles/js/Styles";

function EventItem({ event, onEdit, onCalendar }) {

  const style = Style();

  const ColoredLine = ({ color }) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: 0,
              marginBottom: 12,
              height: 1
          }}
      />
  );

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Card style={{ textAlign: 'left', padding: 12, marginBottom: 8 }}>
          <Grid container spacing={2}>
            <Grid item xs={true}>
              <Grid container>
                <Grid item xs={true}>
                  <Box
                    display="flex"
                    justifyContent="left"
                    alignItems="center"
                    height="100%"> 
                    <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 2, marginBottom: '0.4rem', fontSize: 16, color: '#6C6C6C', textAlign: 'left'}}>
                      <b>{event.name}</b>
                    </p>
                  </Box>
                </Grid>
                <Grid item>
                  <div style={{paddingTop: 4}}>
                    <Tooltip title="Editar">
                      <span>
                        <IconButton onClick={() => {onEdit(event)}}>
                          <EditRoundedIcon fontSize="small"/>
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Calendario">
                      <span>
                        <IconButton onClick={() => {onCalendar(event)}}>
                          <CalendarMonthRoundedIcon fontSize="small"/>
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <ColoredLine />
                </Grid>
                <Grid item xs={12} >
                  <p className={style.ellipseableText} style={{ 'WebkitLineClamp': 4, marginBottom: 0, fontSize: 15, color: 'black', textAlign: 'left' }}>
                    <i>{event.description}</i>
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );

}

export default EventItem;
